module.exports = __webpack_public_path__ + "resource/img/image049.d418584b.png";